import React, { Component } from 'react';

import { Form, Row, Col, Button, Modal, message, Checkbox } from 'antd';
import { Message } from 'semantic-ui-react'

import LicensingFormEmailEditDialog from '../components/LicensingFormEmailEditDialog';

import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import { QUESTIONNAIRE_EMAIL_SEND_MODE } from '../../../../../utils/QuestionnaireEmailSendMode';

class AnswereeSelectDialog extends Component {
  state = {
    
  };

  componentDidMount () {
    
  }

  componentDidUpdate() {
    const { 
      selectAnswereesActionStatus,
    } = this.props;

    // 选择Answeree成功
    if (selectAnswereesActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Answeree is selected successfully!');
      this.props.loadLicensingForms();
      this.props.loadAnswers();

      this.props.initSelectAnswereesActionStatus();

      this.props.resetLicensingFormEmailEditModalDialog();
      this.props.resetAnswereeSelectModalDialog();
    } 

    // 选择Answeree失败
    if (selectAnswereesActionStatus === ACTION_STATUS.ERROR) {
      this.props.initSelectAnswereesActionStatus();
    }
  }

  selectAllButtonOnClicked = () => {
    this.props.selectAllAnsweree();
  }

  selectInvertButtonOnClicked = () => {
    this.props.selectInvertAnsweree();
  }

  onChange = (e, value) => {
    console.log('checked = ', e.target.checked);
    this.props.answereeCheckChanged(e.target.checked, value.userAccountName);

    const {
      pmGroupArray,
    } = this.props;

    console.log(pmGroupArray);
  };

  // Submit Create/Edit Investor Net Value
  submitButtonOnClicked = () => {
    const {
      selectedLicensingForms,
      pmGroupArray
    } = this.props;

    const userAccountNameList = [];
    pmGroupArray.forEach(pmArray => {
      pmArray.forEach(userAccount => {
        if (userAccount.checked) {
          userAccountNameList.push(userAccount.userAccountName);
        }
      })
    });

    if (userAccountNameList.length === 0) {
      message.warning("Please select one answeree at least!");
      return;
    }

    // this.props.selectAnswerees(userAccountNameList, selectedLicensingForms[0].guid);
    this.props.openLicensingFormEmailEditModalDialog(QUESTIONNAIRE_EMAIL_SEND_MODE.ANSWEREE_SELECT, {
      userAccountNameList,
      licensingFormGuid: selectedLicensingForms[0].guid,
    });
  }

  render() {
    const {
      answereeSelectControlModal,
      pmGroupArray,
      answerArray,
      selectedLicensingForms,
      selectAnswereesActionStatus,
    } = this.props;

    const {
      isOpened,
      respErrMsg,
    } = answereeSelectControlModal;

    // const isLoading = selectAnswereesActionStatus === ACTION_STATUS.LOGINING; 
    const isLoading = false;
    
    return (
      <div>
        <Modal
          title='Select Answeree'
          centered
          width={800}
          visible={isOpened}
          confirmLoading={isLoading}
          onOk={this.submitButtonOnClicked}
          onCancel={() => this.props.resetAnswereeSelectModalDialog()}
          destroyOnClose={true}
          maskClosable={false}
          okText="Submit"
          cancelText="Cancel"
        >
          <div style={{ marginBottom: 10 }}>
            <Button 
              onClick={this.selectAllButtonOnClicked} 
              size='small'
              type="primary">
              Select All
            </Button>

            <Button 
              onClick={this.selectInvertButtonOnClicked} 
              size='small'
              style={{ marginLeft: 10 }}
              type="primary">
              Select Invert
            </Button>
          </div>

          {/* <Form layout="horizontal"> */}
            {
              pmGroupArray.map((pmArray, index) => {
                return (
                  <Row gutter={24} key={ index }>
                    {
                      pmArray.map((value, index) => {
                        return (
                          <Col span={6} key={ value.userAccountName }>
                            <Checkbox checked={ value.checked } onChange={(e) => this.onChange(e, value)}>
                              { value.englishName }
                            </Checkbox>
                          </Col>
                        );
                      })
                    }
                  </Row>
                );
              })
            }
          {/* </Form> */}
          {/* {
            !!respErrMsg &&  
            <Message negative>
                <Message.Header>Response Error Message</Message.Header>
              <p>{ respErrMsg }</p>
            </Message>
          } */}
        </Modal>

        <LicensingFormEmailEditDialog {...this.props} />
      </div>
    );
  }
}

export default AnswereeSelectDialog;